import { render, staticRenderFns } from "./ExpirationTimeSelector.vue?vue&type=template&id=0a84bdfe&"
import script from "./ExpirationTimeSelector.vue?vue&type=script&lang=ts&"
export * from "./ExpirationTimeSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports